import Swal from 'sweetalert2'

export default {
  install: (app) => {
    app.config.globalProperties.$actionSheets = async (description, optionsArray = [], options = {}) => {
      if (!Array.isArray(optionsArray) || optionsArray.length === 0) return null

      return new Promise((resolve) => {
        Swal.fire({
          title: '',
          text: description || 'Seleccione una opción',
          html: `
            <div class="swal-text">${description || ''}</div>
            <div class="swal-options">
              ${optionsArray.map((opt, i) =>
                `<button data-index="${i}">${opt}</button>`).join('')}
                 <button data-index="-1">Cancelar</button>
            </div>
          `,
          showConfirmButton: false,
          showCancelButton: false,
          //cancelButtonText: options.cancelText || 'Cancelar',
          customClass: {
            popup: 'text-sm',
            htmlContainer: 'swal-options-list',
          },
          willOpen: () => {
            // Delegamos eventos a los botones internos
            const container = Swal.getHtmlContainer()
            container.querySelectorAll('button').forEach(btn => {
              btn.addEventListener('click', () => {
                const index = parseInt(btn.dataset.index)
                Swal.close()
                if(index >= 0) { 
                  resolve(index) 
                } else {
                  resolve(null)
                }
              })
            })
          },
          ...options,
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.cancel) {
            resolve(null)
          }
        })
      })
    }
  }
}
